import { render } from "./FieldAddSettings.vue?vue&type=template&id=56cb9856"
import script from "./FieldAddSettings.vue?vue&type=script&lang=js"
export * from "./FieldAddSettings.vue?vue&type=script&lang=js"

import "./FieldAddSettings.vue?vue&type=style&index=0&id=56cb9856&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__